import * as React from 'react';

type ChildWithID = React.ReactNode & {
  props: {
    id: string;
  };
};

type Props = {
  activeView?: string;
  children: ChildWithID | ChildWithID[];
};

// @ts-ignore
const isChildWithID = (item): item is ChildWithID => !!item?.props?.id;

/**
 A view switcher implements display control between N child states. Each direct child node
 requires an `id` property which used to control the displayed view.

 A console error is thrown if any direct child does not include an `id` 
 */
export const ContentSwap = ({ activeView, children, ...props }: Props) => (
  <div data-test="content-swap" {...props}>
    {!activeView
      ? children
      : React.Children.toArray(children).filter((child) => {
          if (isChildWithID(child)) {
            return child.props.id === activeView;
          }

          // eslint-disable-next-line
          console.error(
            'Children controlled by content swap must implement an `id` property',
            child,
          );

          return false;
        })}
  </div>
);
